/* eslint-disable max-len */
/* eslint-disable react/no-unescaped-entities */
import React, { useState } from "react";
import "../../styles/LandingPageCard.css";
import LandingPageFile from "../../assets/logos/LandingPageFile.svg";
import ArrowUpRight from "../../assets/logos/ArrowUpRight.svg";
import People from "../../assets/logos/People.svg";
import Information from "../../assets/logos/Information.svg";
import DataBase from "../../assets/logos/DataBase.svg";

const cardsData = [
  {
    id: 1,
    icon: People,
    title: "Deploy Persona-Based Chatbots",
    fullText:
      "Giving personalities and personas to generative AI-powered chatbots can make user experiences more engaging and satisfying.",
  },
  {
    id: 2,
    icon: Information,
    title: "Integrate Generative AI",
    fullText:
      "Our AI team can help you implement generative AI solutions that are compatible with your applications and workflows, developing and refining prompts to produce relevant outcomes.",
  },
  {
    id: 3,
    icon: DataBase,
    title: "Develop AI Strategy",
    fullText:
      "With many generative AI tools available, using separate solutions for each task can create a disconnected environment. We help you build a unified strategy.",
  },
];

const LandingPageCard = () => {
  const [hoveredCardId, setHoveredCardId] = useState(null);

  const getTrimmedText = (text, limit = 100) => (text.length > limit ? `${text.slice(0, limit)}...` : text);

  return (
    <div className="LandingPageCard">
      <div className="LandingPageCardCotent">
        <p>Learn how IVA works</p>
        <h1>
          Explore IVA’s AI solutions to enhance efficiency, streamline processes, and drive smarter decision-making for a transformative workflow.
        </h1>
      </div>

      <div className="cards">
        {cardsData.map((card) => (
          <div
            key={card.id}
            className="card"
            role="article"
            onMouseEnter={() => setHoveredCardId(card.id)}
            onMouseLeave={() => setHoveredCardId(null)}
          >
            <img src={card.icon} alt="Card Icon" className="LandingPageFile" />
            <div className="WrapCard">
              <h2 className="CardHeader">{card.title}</h2>
              <h3 className="CardPara" title={card.fullText}>
                {card.fullText}
              </h3>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default LandingPageCard;
